module.exports = {
  // COMMON
  // hint: {
  //   delete: {
  //     really: {
  //       category: {
  //         title: 'Sicher?',
  //         message: 'Sind Sie sich sicher, dass Sie diese Kategorie irreversibel löschen möchten?',
  //       },
  //       categoryData: {
  //         title: 'Sicher?',
  //         message: 'Sind Sie sich sicher, dass Sie dieses Kategorie-Datum irreversibel löschen möchten?',
  //       },
  //       mediaMultiple: {
  //         title: 'Sicher?',
  //         message: 'Sind Sie sich sicher, dass Sie die {{nrOfElements}} gewählten Dateien irreversibel löschen möchten?',
  //       },
  //       media: {
  //         title: 'Sicher?',
  //         message: 'Sind Sie sich sicher, dass Sie die gewählte Datei irreversibel löschen möchten?',
  //       },
  //     },
  //   },
  //   imageField: {
  //     hiddenImages: '{{nrOfElements}} Bild(er) nur im Vollbildmodus sichtbar',
  //     empty: 'Keine Bilder zugewiesen',
  //     dirty: 'Änderungen in diesem Feld werden erst nach dem Speichern wirksam',
  //     placeholder: 'Kein Bild Zugewiesen',
  //   },
  //   fileField: {
  //     hiddenFiles: '{{nrOfElements}} Datei(en) nur im Vollbildmodus sichtbar',
  //     empty: 'Keine Dateien zugewiesen',
  //     dirty: 'Änderungen in diesem Feld werden erst nach dem Speichern wirksam',
  //     placeholder: 'Keine Datei Zugewiesen',
  //   },
  // },
  // status: {
  //   progress: {
  //     save: 'Daten werden gespeichert...',
  //     load: 'Daten werden geladen...',
  //     login: 'Anmeldung im Gange...',
  //     move: 'Daten werden verschoben...',
  //     import: 'Daten werden verarbeitet...',
  //   },
  //   done: {
  //     save: 'Daten gespeichert',
  //     assigned: 'Zuordnung gespeichert',
  //     load: 'Daten geladen',
  //     move: 'Daten verschoben',
  //     refresh: 'Daten aktualisiert',
  //     import: 'Daten importiert',
  //     dataRefreshed: 'Daten aktualisiert',
  //     cut: 'Ausgeschnitten',
  //     paste: 'Eingefügt',
  //     processed: 'Daten verarbeitet',
  //     copyToClipboard: 'Daten in die Zwischenablage kopiert',
  //     setStatus: 'Status gesetzt',
  //     generate: 'Generiert',
  //   },
  //   problem: {
  //     copyToClipboard: 'Daten konnten nicht in die Zwischenablage kopiert werden.',
  //     generate: 'Generieren fehlgeschlagen.',
  //   },
  //   nothingChanged: 'Nichts verändert',
  //   activationRegister: {
  //     successUserMessages: {
  //       setStatusActive: 'Ihr Benutzer wurde aktiviert und kann ab sofort verwendet werden.',
  //       setEmailConfirmed: 'Ihre E-Mail-Adresse wurde bestätigt.',
  //       setMobileConfirmed: 'Ihre Rufnummer wurde bestätigt.',
  //       password: 'Ihr neues Passwort wurde gesetzt und kann ab sofort verwendet werden.',
  //     },
  //   },
  // },
  // table: {
  //   nrOfElementsPerPage: '{{nrOfElements}} Einträge / Seite',
  //   pageingInfo: 'Zeige {{-pageEntriesStart}} bis {{-pageEntriesEnd}} von {{-nrOfElements}} Einträgen',
  //   head: {
  //     default: '',
  //   },
  //   columnInfo: {
  //     headline: 'Spalten-Beschreibung',
  //   },
  // },
  // form: {
  //   fieldInfo: {
  //     headline: 'Feld-Beschreibung',
  //   },
  //   fields: {
  //     periodAir: {
  //       title: {
  //         from: 'Von {{ts}}',
  //         to: 'Bis {{ts}}',
  //       },
  //       placeholder: {
  //         from: 'Von',
  //         to: 'Bis',
  //         duration: 'Dauer',
  //       },
  //       from: {
  //         title: 'Von',
  //       },
  //       to: {
  //         title: 'Bis',
  //       },
  //     },
  //     airDateTimePickerSet: {
  //       daily: 'täglich',
  //       monthly: 'monatlich',
  //     },
  //     autoComplete: {
  //       placeholderDefault: 'Keine Angabe',
  //     },
  //     autoCompleteResourcePicker: {
  //       filterPlaceHolder: 'Suchbegriff eingeben',
  //     },
  //     autoCompleteResourcePickerMulti: {
  //       nrOfChosenElements: '{{nrOfElements}} gewählt',
  //     },
  //     emailConfirmation: {
  //       sentAt: 'Bestätigungs-Email versendet: {{date}} um {{time}}',
  //       confirmedAt: 'Bestätigt: {{date}} um {{time}}',
  //       missingConfirmation: 'Noch nicht bestätigt',
  //       missingConfirmationMail: 'Noch keine Bestätigungs-Email versendet',
  //     },
  //     mobileConfirmation: {
  //       sentAt: 'Bestätigungs-SMS versendet: {{date}} um {{time}}',
  //       confirmedAt: 'Bestätigt: {{date}} um {{time}}',
  //       missingConfirmation: 'Noch nicht bestätigt',
  //       missingConfirmationSMS: 'Noch keine Bestätigungs-SMS versendet',
  //     },
  //     userAndPassword: {
  //       missingPassword: 'Es wurde noch kein Passwort vergeben!',
  //       options: {
  //         headline: 'Passwort setzen',
  //         setPassword: 'Neues Passwort generieren',
  //         setAndSendViaMail: 'Per Mail senden',
  //         setAndSendViaSMS: 'Per SMS senden',
  //         setAndCopy: 'In die Zwischenablage kopieren',
  //       },
  //       confirmedViaMailAt: 'Passwort per Mail: {{date}} um {{time}}',
  //       confirmedViaSmsAt: 'Passwort per SMS: {{date}} um {{time}}',
  //       confirmedViaMailAndSmsAt: 'Passwort per Mail & SMS: {{date}} um {{time}}',
  //     },
  //     passwordGenerator: {
  //       noChange: 'Passwort unverändert',
  //       fields: {
  //         noChange: {
  //           name: 'Passwort nicht verändern',
  //           placeholder: 'Passwort unverändert',
  //         },
  //         password: {
  //           name: 'Passwort selbst setzen',
  //           placeholder: 'Passwort',
  //         },
  //         generatePasswordOfLength: {
  //           name: 'Passwort generieren',
  //           placeholder: 'Passwort-Länge',
  //         },
  //       },
  //     },
  //     routePicker: {
  //       summary: {
  //         multi: '{{nrOfElements}} Route(n) gewählt',
  //         single: {
  //           selected: 'Route gewählt',
  //           empty: 'keine Route gewählt',
  //         },
  //       },
  //     },
  //     location: {
  //       location: {
  //         title: 'Location',
  //         placeholder: 'Location'
  //       },
  //       locationOptions: {
  //         label: 'Location - Url',
  //         description: 'Das ist die Link - Adresse die anstatt der generierten Variante verwendet werden soll.'
  //       }
  //     },
  //     timeRangeByCode: {
  //       invalidCodeGiven: 'Ungütlige Eingabe',
  //       rangeLabel: {
  //         startPrefix: 'von:',
  //         endPrefix: 'bis:'
  //       },
  //       tooltip: {
  //         default: {
  //           title: 'Verwendung',
  //           titleRight: '',
  //           message: 'Hier einige Beispiele wie dieses Feld verwendet werden kann:<br><br>2024: ein Jahr: 2024<br>12: ein Monat im aktuellen Jahr: 2024-12<br>13: Kurze Jahresangabe: 2013<br>Q1: ein Quartal im aktuellen Jahr: 2024-Q1<br>12-Q2: ein Quartal eines Jahres: 2012-Q2<br>13-12: ein Monat eines Jahres: 2013-12'
  //         },
  //         m: {
  //           title: 'Verwendung',
  //           titleRight: '',
  //           message: 'Hier einige Beispiele wie dieses Feld verwendet werden kann:<br><br>12: ein Monat im aktuellen Jahr: 2024-12<br>Q1: Start-Monat eines Quartals im aktuellen Jahr: 2024-1'
  //         },
  //         q: {
  //           title: 'Verwendung',
  //           titleRight: '',
  //           message: 'Hier einige Beispiele wie dieses Feld verwendet werden kann:<br><br>Q1: ein Quartal im aktuellen Jahr: 2024-Q1',
  //         },
  //         y: {
  //           title: 'Verwendung',
  //           titleRight: '',
  //           message: 'Hier einige Beispiele wie dieses Feld verwendet werden kann:<br><br>2024: ein Jahr: 2024<br>13: Kurze Jahresangabe: 2013',
  //         },
  //         mq: {
  //           title: 'Verwendung',
  //           titleRight: '',
  //           message: 'Hier einige Beispiele wie dieses Feld verwendet werden kann:<br><br>12: ein Monat im aktuellen Jahr: 2024-12<br>Q1: ein Quartal im aktuellen Jahr: 2024-Q1',
  //         },
  //         my: {
  //           title: 'Verwendung',
  //           titleRight: '',
  //           message: 'Hier einige Beispiele wie dieses Feld verwendet werden kann:<br><br>2024: ein Jahr: 2024<br>12: ein Monat im aktuellen Jahr: 2024-12<br>13: Kurze Jahresangabe: 2013<br>Q1: Start-Monat eines Quartals im aktuellen Jahr: 2024-1<br>12-Q2: Start-Monat eines Quartals eines Jahres: 2012-4<br>13-12: ein Monat eines Jahres: 2013-12',
  //         },
  //         qy: {
  //           title: 'Verwendung',
  //           titleRight: '',
  //           message: 'Hier einige Beispiele wie dieses Feld verwendet werden kann:<br><br>2024: ein Jahr: 2024<br>12: ein Monat im Quartal im aktuellen Jahr: 2024-Q4<br>13: Kurze Jahresangabe: 2013<br>Q1: ein Quartal im aktuellen Jahr: 2024-Q1<br>12-Q2: ein Quartal eines Jahres: 2012-Q2<br>13-12: ein Monat im Quartal eines Jahres: 2013-Q4',
  //         },
  //         mqy: {
  //           title: 'Verwendung',
  //           titleRight: '',
  //           message: 'Hier einige Beispiele wie dieses Feld verwendet werden kann:<br><br>2024: ein Jahr: 2024<br>12: ein Monat im aktuellen Jahr: 2024-12<br>13: Kurze Jahresangabe: 2013<br>Q1: ein Quartal im aktuellen Jahr: 2024-Q1<br>12-Q2: ein Quartal eines Jahres: 2012-Q2<br>13-12: ein Monat eines Jahres: 2013-12',
  //         }
  //       }
  //     },
  //   },
  // },
  // filter: 'Filter',
  // dataValues: {
  //   boolean: {
  //     all: 'Alle',
  //     1: 'Ja',
  //     0: 'Nein',
  //     true: 'Ja',
  //     false: 'Nein',
  //   },
  //   options: {
  //     none: 'Keine(r)',
  //     unspecified: 'Nicht Angegeben',
  //   },
  //   orderDirection: {
  //     ASC: 'Aufsteigend',
  //     DESC: 'Absteigend',
  //   },
  //   scheduler: {
  //     viewPeriod: {
  //       day: 'Tag',
  //       week: 'Woche',
  //       month: 'Monat',
  //     },
  //   },
  // },
  // trees: {
  //   empty: 'Keine Einträge gefunden',
  // },
  // tooltip: {
  //   table: {
  //     headSort: {
  //       title: 'Schon gewusst?',
  //       message: 'Wenn man auf die Überschriften in Tabellen klickt, kann man nach den jeweiligen Spalten sortieren.<br><br>Bei gedrückter Strg-Taste sogar nach mehreren gleichzeitig.<br><br>Zusatz: Nicht alle Felder eignen sich für eine Sortierung. Wenn also beim Klick darauf nichts passiert, sind die Felder nicht dafür konfiguriert worden.',
  //     },
  //   },
  // },
  // summary: {
  //   imageManagement: {
  //     selected: 'Ausgewählte Bilder',
  //     shown: 'Sichtbare Bilder',
  //     filtered: 'Gefilterte Bilder',
  //     all: 'Alle Bilder',
  //   },
  //   fileManagement: {
  //     selected: 'Ausgewählte Dateien',
  //     shown: 'Sichtbare Dateien',
  //     filtered: 'Gefilterte Dateien',
  //     all: 'Alle Dateien',
  //   },
  // },
  language: {
    language: 'Language',
    de: 'German',
    en: 'English',
  },


  // SPECIAL
  // modal: {
  //   instantUploader: {
  //     title: 'Hochladen',
  //   },
  //   credentials: {
  //     showReLogin: {
  //       title: 'Anmeldung',
  //       dialogText: 'Ihre Sitzung ist abgelaufen - Bitte geben Sie ihre Benutzerdaten erneut ein.',
  //     },
  //     showReset: {
  //       title: 'Passwort zurücksetzen',
  //       dialogText: 'Bitte füllen Sie das unten stehende Formular aus um ihr Passwort zurück zu setzen. Sie erhalten direkt im Anschluss eine E-Mail mit ihren neuen Zugangsdaten.',
  //     },
  //     showRegister: {
  //       title: 'Registrieren',
  //       dialogText: 'Bitte füllen Sie das unten stehende Formular aus um sich neu zu registrieren. Sie erhalten direkt im Anschluss eine E-Mail mit ihren Zugangsdaten.',
  //     },
  //   },
  //   imageManagement: {
  //     title: 'Bild-Verwaltung',
  //     subTitle: {
  //       multiSelect: 'Mehrfach - Auswahl',
  //       singleSelect: 'Einzel - Auswahl',
  //     },
  //   },
  //   fileManagement: {
  //     title: 'Bild-Verwaltung',
  //     subTitle: {
  //       multiSelect: 'Mehrfach - Auswahl',
  //       singleSelect: 'Einzel - Auswahl',
  //     },
  //   },
  //   tagAssignment: {
  //     title: 'Tags',
  //   },
  //   tagAssignmentMediaEnhanced: {
  //     title: 'Bild-Details',
  //   },
  // },
  // mediaManagement: {
  //   detailsSummary: {
  //     imageID: 'Bild-ID',
  //     fileID: 'Datei-ID',
  //     resolution: 'Abmaße',
  //     size: 'Größe',
  //     createdAt: 'Upload',
  //     name: 'Name',
  //     permissions: {
  //       owner: 'Besitzer',
  //       auth: 'Auth-Rechte',
  //       public: 'Public-Rechte',
  //     },
  //   },
  //   details: {
  //     modalTitle: 'Details',
  //     fields: {
  //       copyright: {
  //         label: 'Copyright',
  //         description: '',
  //         info: '',
  //       },
  //       info: {
  //         label: 'Info',
  //         description: '',
  //         info: '',
  //       },
  //     },
  //     trls: {
  //       name: {
  //         label: 'Name',
  //         description: '',
  //         info: '',
  //       },
  //       title: {
  //         label: 'Titel',
  //         description: '',
  //         info: '',
  //       },
  //       alt: {
  //         label: 'Alternativer Text',
  //         description: '',
  //         info: '',
  //       },
  //       info: {
  //         label: 'Info',
  //         description: '',
  //         info: '',
  //       },
  //       description: {
  //         label: 'Beschreibung',
  //         description: '',
  //         info: '',
  //       },
  //     },
  //   },
  //   recentlyUploaded: 'gerade hochgeladen',
  //   filters: {
  //     originalName: {
  //       label: 'Name',
  //       description: 'Wenn man die ID eines Bildes kennt kann man hier danach suchen.<br>Mit der Eingabe <b>#27</b> wird die Liste also auf das Bild mit der ID 27 eingeschränkt.',
  //       info: '',
  //     },
  //     artiasTimeRange: {
  //       label: 'Zeitraum',
  //       description: '',
  //       info: '',
  //     },
  //   },
  //   dataValues: {
  //     orderField: {
  //       mediaID: 'Erstellt am',
  //       originalName: 'Name',
  //       sizeInBytes: 'Größe',
  //       extension: 'Dateierweiterung',
  //       mimeType: 'Typ',
  //       width: 'Breite',
  //       height: 'Höhe',
  //     },
  //   },
  // },
  // imageManagement: {
  //   actions: {
  //     headlines: {
  //       common: 'Allgemein:',
  //       selectedElements: 'Ausgewählte Bilder:',
  //     },
  //   },
  //   filters: {
  //     headlines: {
  //       filter: 'Filter:',
  //       sort: 'Sortierung:',
  //     },
  //   },
  // },
  // tagAssignment: {
  //   filters: {
  //     name: {
  //       label: 'Name',
  //       description: '',
  //       info: '',
  //     },
  //     selected: {
  //       label: 'Ausgewählt',
  //       description: '',
  //       info: '',
  //     }
  //   },
  // },
  // categoryData: {
  //   properties: {
  //     value: {
  //       label: 'Wert',
  //       description: '',
  //       info: '',
  //     },
  //     color: {
  //       label: 'Farbe',
  //       description: '',
  //       info: '',
  //     },
  //     priority: {
  //       label: 'Priorität',
  //       description: '',
  //       info: '',
  //     },
  //     config: {
  //       label: 'Konfiguration',
  //       description: '',
  //       info: '',
  //     },
  //   },
  //   trls: {
  //     name: {
  //       label: 'Name',
  //       description: '',
  //       info: '',
  //     },
  //     description: {
  //       label: 'Beschreibung',
  //       description: '',
  //       info: '',
  //     },
  //     information: {
  //       label: 'Information',
  //       description: '',
  //       info: '',
  //     },
  //   },
  //   showInsert: {
  //     modalTitle: 'Tag anfügen',
  //   },
  // },



  // USER COMMUNICATION
  // mails: {
  //   userEmailConfirmation: {
  //     confirm: {
  //       subject: 'E-Mail-Adresse bestätigen',
  //       content: 'Bitte bestätigen Sie mit dem folgenden Link Ihre E-Mail-Adresse: \n\n{{-activationUrl}}',
  //     },
  //     sendPassword: {
  //       subject: 'Zugangsdaten abrufen',
  //       content: 'Mit dem folgenden Link können Sie Ihre Zugangsdaten abrufen: \n\n{{-activationUrl}}',
  //     },
  //   },
  // },
  // sms: {
  //   userMobileConfirmation: {
  //     confirm: 'Bitte bestätigen Sie mit dem folgenden Link Ihre Rufnummer: \n\n{{-activationUrl}}',
  //     sendPassword: 'Mit dem folgenden Link können Sie Ihre Zugangsdaten abrufen:\n\n{{-activationUrl}}',
  //   },
  // },
}
